// @ts-nocheck
import {
  Component, ElementRef, Input, Renderer2,
} from '@angular/core';
import { UIKitIllustrationName } from '../../illustration/illustration';

import { UIKitIllustrationRegistry } from '../../illustration/illustration.registry';

@Component({
  selector: 'lib-illustration',
  templateUrl: './illustration.component.html',
  styleUrls: ['./illustration.component.scss'],
  exportAs: 'libIllustration',
})
export class IllustrationComponent {
  @Input()
  set name(name: UIKitIllustrationName) {
    if (this.svgElement) {
      this.element.nativeElement.removeChild(this.svgElement);
    }

    const data = this.illustrationRegistry.getIllustration(name);

    this.svgElement = this.svgElementFromString(data);

    this.element.nativeElement.appendChild(this.svgElement);
  }

  @Input()
  set stroke(color: string) {
    this.element.nativeElement.setAttribute('class', `stroke-${color || 'default'}`);
  }

  private svgElement: SVGElement;

  constructor(private element: ElementRef, private illustrationRegistry: UIKitIllustrationRegistry) { }

  private svgElementFromString(data: string): SVGElement {
    const div: HTMLDivElement = document?.createElement('div');
    div.innerHTML = data;
    const svgElement = div.querySelector('svg') as SVGElement || document?.createElementNS('http://www.w3.org/2000/svg', 'path');
    return svgElement;
  }
}
